import { isStringJSON } from "src/main/resources/js/lib/util/isStringJSON";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { BaseMiniPopUpControl } from "./BaseMiniPopUpControl";

export class ListMiniPopupControl extends BaseMiniPopUpControl {
  constructor(options, initialSearchTerm) {
    super(options);
    this.template =
      options.template || "tmpl/controls/ConfigListMiniPopUp.html";
    this.newListInputHolderId = this.id + "_newListInputHolder";
    this.hasCreateNewButtonFunctionality =
      options.hasCreateNewButtonFunctionality || false;

    this.currentSearchTerm = !initialSearchTerm || isStringJSON(initialSearchTerm) ? "" : initialSearchTerm;
  }
  beforePosition() {
    if (this.hasCreateNewButtonFunctionality && !this.justNewList) {
      $("#" + this.newListInputHolderId).hide();
      $("#" + this.formId)
        .find(".createNewList")
        .show();
    } else {
      $("#" + this.newListInputHolderId).show();
      $("#" + this.formId)
        .find(".createNewList")
        .hide();
    }
    this.toggleVisibleElements();
  }
  toggleVisibleElements() {}
  populateSearchTerm() {
    $("#" + this.formId)
      .find("input:text")
      .val(this.currentSearchTerm);
  }
  afterOpen() {
    this.populateSearchTerm();
  }
  addExtraListeners(_this) {
    const searchGuid = TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onSearch,
      function (event) {
        if(isStringJSON(event.searchString)){
          _this.currentSearchTerm = "";
        }
        else {
          _this.currentSearchTerm = event.searchString;
        }
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onSearch, searchGuid));

    const logoutGuid = TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.currentSearchTerm = "";
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onLogoutResponse, logoutGuid));
  }
  preLoadData(callback) {
    if (this.justNewList) {
      this.currentSearchTerm = "";
    }
    callback();
  }
  addEvents() {
    //TODO this gets called every time the add to list dialog is launched...
    var _this = this;

    $("#" + this.id).on("click", ".createNewList", function (element) {
      clearTimeout(_this.closeTimer);

      $("#" + _this.formId)
        .find(".createNewList")
        .fadeOut("fast", function () {
          $("#" + _this.newListInputHolderId).fadeIn("fast", function () {
            _this.repositionPopUp(_this.currentElement);
            setTimeout(function () {
              $("#" + _this.formIds)
                .find("input:text")
                .trigger("focus");
            }, 10);
          });
        });
      return false;
    });
  }
  removeEvents(){
    $("#" + this.id).off("click", ".createNewList");
  }
  setPassedEventData(event) {
    if (event.resourceIds) {
      this.resourceIds = event.resourceIds;
    }
    this.justNewList = event.justNewList;
  }
  fetchLists(callback) {
    callback();
  }
}
